import HttpRequest from "../request";
import type { ICheckCodeParams, IForgetParams, ILoginParams, IRegistParams } from "./types";
import type { Response } from "../request";
import { UserApi } from "../api";

// 企业认证仅处理本站账号；跨区身份由存量企业主流程处理，不触发 C 端账号迁移。
const enterpriseAuthOptions = { headers: { 'X-Doclingo-Auth-Scope': 'enterprise' } }

export default {
    login<T>(data: ILoginParams): Promise<Response<T>> {
        return HttpRequest.post(UserApi.login, data, enterpriseAuthOptions)
    },
    getUserInfo<T>(): Promise<Response<T>> {
        return HttpRequest.get(UserApi.getUserInfo, null)
    },
    getAccountRegist<T>(data: IRegistParams): Promise<Response<T>> {
        return HttpRequest.post(UserApi.getAccountRegist, data, enterpriseAuthOptions)
    },
    getAccountForget<T>(data: IForgetParams): Promise<Response<T>> {
        return HttpRequest.post(UserApi.getAccountForget, data, enterpriseAuthOptions)
    },
    getAccountEmailCode<T>(data: ICheckCodeParams): Promise<Response<T>> {
        return HttpRequest.post(UserApi.getAccountEmailCode, data)
    },
    getAccountGoogleLogin<T>(data :{code: string}): Promise<Response<T>> {
        return HttpRequest.get(UserApi.getAccountGoogleLogin, data)
    },
    getAccountLiunxDoLogin<T>(data :{code: string}): Promise<Response<T>> {
        return HttpRequest.get(UserApi.getAccountLiunxDoLogin, data)
    },
    getAccountAppleLogin<T>(data :{queryKey: string}): Promise<Response<T>> {
        return HttpRequest.get(UserApi.getAccountAppleLogin, data)
    },
    // getWxauthUrlApi<T>(data: ILoginParams): Promise<Response<T>> {
    //     return HttpRequest.post(UserApi.getWxauthUrlApi, data)
    // },
    getWxauthCodeLoginApi<T>(data :{code: string}): Promise<Response<T>> {
        return HttpRequest.get(UserApi.getWxauthCodeLoginApi, data)
    },
    getQQauthCodeLoginApi<T>(data :{code: string}): Promise<Response<T>> {
        return HttpRequest.get(UserApi.getQQauthCodeLoginApi, data)
    },
    gettWitterCodeLoginApi<T>(data: {oauthToken: string, oauthVerifier: string}): Promise<Response<T>> {
        return HttpRequest.post(UserApi.gettWitterCodeLoginApi, data)
    },
    getTwitterOauthUrlApi<T>(): Promise<Response<T>> {
        return HttpRequest.get(UserApi.getTwitterOauthUrlApi, null)
    },
    getFacebookOauthlogin<T>(data: {inputToken: string}): Promise<Response<T>> {
        return HttpRequest.post(UserApi.getFacebookOauthlogin, data)
    },
    getLogout<T>(): Promise<Response<T>> {
        return HttpRequest.get(UserApi.getLogout, null)
    },
    getRequestConfigById<T>(data: {thisId: string}): Promise<Response<T>> {
        return HttpRequest.get(UserApi.getRequestConfigById, data)
    },
    getModifyCompareCfgApi<T>(data: {compareStyleType: number}): Promise<Response<T>> {
        return HttpRequest.post(UserApi.getModifyCompareCfgApi, data)
    },
    getAccountInfoEdit<T>(data: any): Promise<Response<T>> {
        return HttpRequest.post(UserApi.getAccountInfoEdit, data)
    },
    getDeleteAccount<T>(): Promise<Response<T>> {
        return HttpRequest.post(UserApi.getDeleteAccount, null)
    },
}
